import React, { useState } from 'react';
import { Section } from '../ui/Section';
import { Plus, Minus } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Necesito ingredientes raros o caros?',
    a: 'No. Está pensado con comida real y opciones simples que encontrás en cualquier súper argentino.'
  }, {
    q: '¿Tengo que pesar y medir todo?',
    a: 'No. Se usa una guía visual de porciones. Sin balanza, sin calculadora.'
  }, {
    q: '¿Es un plan médico?',
    a: 'No. Es un producto educativo y de organización. Si tomás medicación, consultá con tu médico ante cambios importantes.'
  }, {
    q: '¿Me sirve si cocino para toda la familia?',
    a: 'Sí. Hay una versión de menú para familia y swaps para adaptar.'
  }, {
    q: '¿Qué pasa si un día no cocino?',
    a: 'Para eso existe el Bono 3: Salvavidas 10 Min. Tenés 10 opciones express para ese día.'
  }, {
    q: '¿Cuándo recibo el PDF?',
    a: 'Inmediatamente después del pago. Descarga directa, sin espera.'
  }];
  return <Section background="off-white" data-id="element-97">
      <h2 className="text-3xl font-bold text-center mb-12 text-stone-900" data-id="element-98">
        Preguntas frecuentes
      </h2>

      <div className="max-w-2xl mx-auto space-y-4" data-id="element-99">
        {faqs.map((faq, i) => <div key={i} className="bg-white rounded-lg border border-stone-200 overflow-hidden" data-id="element-100">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-101">
              <span className="font-bold text-stone-900" data-id="element-102">{faq.q}</span>
              {openIndex === i ? <Minus className="w-5 h-5 text-stone-400 flex-shrink-0" data-id="element-103" /> : <Plus className="w-5 h-5 text-stone-400 flex-shrink-0" data-id="element-104" />}
            </button>
            {openIndex === i && <div className="px-6 pb-6 text-stone-600 animate-in fade-in slide-in-from-top-2 duration-200" data-id="element-105">
                {faq.a}
              </div>}
          </div>)}
      </div>
    </Section>;
}